import React, { Fragment } from 'react';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

const grabNames = ['Electro-hydraulic', 'Mechanical', 'Electro-hydraulic remote control', 'Mechanical remote control'];

class GrabV2 extends React.Component {
    constructor(props) {
        super(props);
        
        this.addGrab = this.addGrab.bind(this);
        this.removeGrab = this.removeGrab.bind(this);
    }

    addGrab() {
        const grabs = _.cloneDeep(this.props.grabs);

        grabs.summary.push({
            type: '',
            quantity: '',
            volume: '',
            maxSWL: '',
        });

        this.props.changeField({ field: 'grabV2', value: grabs });
    }

    removeGrab(index) {
        const grabs = _.cloneDeep(this.props.grabs);
        grabs.summary.splice(index, 1);
        this.props.changeField({ field: 'grabV2', value: grabs });
    }

    render() {
        const { changeField, getError, grabs, confirmed, modifiedFields, underStyle } = this.props;

        return (
            <Fragment>
                {
                    grabs.summary.map((grab, index) => {
                        return (
                            <div key={index} className='row'>
                                <div className='col-xs-3'>
                                    <SelectField
                                        value={grabs.summary[index].type || ''}
                                        onChange={(e, i, value) => {
                                            changeField([
                                                {
                                                    field: `grabV2[summary][${index}].type`,
                                                    value,
                                                },
                                                { field: 'grabbed', value: true },
                                                { field: 'geared', value: true },
                                            ]);
                                        }}
                                        disabled={confirmed}
                                        errorText={getError && getError(`grabV2[summary][${index}].type`)}
                                        maxHeight={200}
                                        name='type'
                                        floatingLabelText='Type'
                                        floatingLabelStyle={{ fontSize: '13px' }}
                                        fullWidth
                                        autoWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`grabV2[summary][${index}].type`) ? underStyle : null}

                                    >
                                        {
                                            grabNames.map((grabName, index) => {
                                                return (<MenuItem
                                                    key={index}
                                                    value={grabName}
                                                    primaryText={grabName}
                                                />);
                                            })
                                        }
                                    </SelectField>
                                </div>
                                <div className={`col-xs-${this.props.fromTc ? '2':'3'}`}>
                                    <NumberField
                                        name='grabV2[summary].quantity'
                                        floatingLabelText='Quantity'
                                        floatingLabelStyle={{ fontSize: '13px' }}
                                        value={grabs.summary[index].quantity || ''}
                                        fullWidth
                                        disabled={!grabs.summary[index].type}
                                        errorText={getError && getError(`grabV2[summary][${index}].quantity`)}
                                        onChange={(e, value) => {
                                            changeField({
                                                field: `grabV2[summary][${index}].quantity`,
                                                value,
                                                type: 'number',
                                            });
                                        }}

                                        underlineStyle={modifiedFields && modifiedFields.includes(`grabV2[summary][${index}].quantity`) ? underStyle : null}

                                    />
                                </div>
                                {
                                    this.props.fromTc !== true ?
                                    <React.Fragment>
                                        <div className='col-xs-3'>
                                            <NumberField
                                                name='grabV2[summary].volume'
                                                floatingLabelText='Volume, cbm'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={grabs.summary[index].volume || ''}
                                                fullWidth
                                                floatNumber
                                                disabled={!grabs.summary[index].type}
                                                errorText={getError && getError(`grabV2[summary].${index}.volume`)}
                                                onChange={(e, value) => {
                                                    changeField({
                                                        field: `grabV2[summary][${index}].volume`,
                                                        value,
                                                        type: 'number',
                                                    });
                                                }}

                                                underlineStyle={modifiedFields && modifiedFields.includes(`grabV2[summary][${index}].volume`) ? underStyle : null}
                                            />
                                        </div>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='grabV2[summary].maxSWL'
                                                floatingLabelText='Max SWL, m3'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={grabs.summary[index].maxSWL || ''}
                                                fullWidth
                                                floatNumber
                                                disabled={!grabs.summary[index].type}
                                                errorText={getError && getError(`grabV2[summary].${index}.maxSWL`)}
                                                onChange={(e, value) => {
                                                    changeField({
                                                        field: `grabV2[summary][${index}].maxSWL`,
                                                        value,
                                                        type: 'number',
                                                    });
                                                }}

                                                underlineStyle={modifiedFields && modifiedFields.includes(`grabV2[summary][${index}].maxSWL`) ? underStyle : null}
                                            />
                                        </div>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='grabV2[summary].volumeMin'
                                                floatingLabelText='Volume min, cbm'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={grabs.summary[index].volumeMin || ''}
                                                fullWidth
                                                floatNumber
                                                disabled={!grabs.summary[index].type}
                                                onChange={(e, value) => {
                                                    changeField({
                                                        field: `grabV2[summary][${index}].volumeMin`,
                                                        value,
                                                        type: 'number',
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className='col-xs-2'>
                                            <NumberField
                                                name='grabV2.summary.volumeMax'
                                                floatingLabelText='Volume max, cbm'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                value={grabs.summary[index].volumeMax || ''}
                                                fullWidth
                                                floatNumber
                                                disabled={!grabs.summary[index].type}
                                                onChange={(e, value) => {
                                                    changeField({
                                                        field: `grabV2[summary][${index}].volumeMax`,
                                                        value,
                                                        type: 'number',
                                                    });
                                                }}
                                            />
                                        </div>
                                    </React.Fragment>
                                }

                                
                                <div className='col-xs-1 middle-xs center-xs' style={{ display: 'flex' }}>
                                    <div style={{ margin: '25px 0 0 0' }}>
                                        {
                                            index === 0 ?
                                                <IconButton
                                                    disabled={confirmed}
                                                >
                                                    <ContentAddIcon
                                                        onClick={this.addGrab}
                                                        color='green'
                                                    />
                                                </IconButton>
                                                :
                                                <IconButton
                                                    disabled={confirmed}
                                                >
                                                    <ContentRemoveIcon
                                                        onClick={() => {
                                                            this.removeGrab(index);
                                                        }}
                                                        color='red'
                                                    />
                                                </IconButton>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </Fragment>);
    }
}

export default GrabV2;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/GrabV2.jsx